<template>
  <pt-bill-back class="pt-bill-back__page"></pt-bill-back>
</template>

<script>
import PtBillBack from 'cps/trust-order/pt-bill-back/withData'
export default {
  name: 'pt-bill-back__view',
  components: {
    'pt-bill-back': PtBillBack
  }
}
</script>
